import { fork, put, takeEvery } from "redux-saga/effects";

import { callApi } from "sagas/helpers/api";
import { setError, setSuccess, startLoading } from "store/appSlice";

import * as CashManagementAccountApi from "../api/CashManagement";
import {
  cashManagementOperationPaths,
  fetchAccounts,
  setList,
} from "./cashManagement.slice";

/** @deprecated */
function* fetchAccountsSaga({
  payload,
}: {
  payload: {
    active: boolean;
    id: string;
  };
  type: string;
}) {
  const { id, active = undefined } = payload;
  const { listing: operationPath } = cashManagementOperationPaths(id);

  yield put(startLoading(operationPath));

  try {
    // @ts-ignore noImplicitAny
    const data = yield callApi(
      CashManagementAccountApi.getCashManagementAccounts,
      id,
      active
    );

    yield put(setList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchAccounts() {
  yield takeEvery(fetchAccounts.type, fetchAccountsSaga);
}

export function* rootSaga() {
  yield fork(watchFetchAccounts);
}
